<template>
  <div class="px-3">
    <h4 id="sidebar-orderdets-title" class="sidebar-title">YOUR<b>ORDER</b></h4>
    <b-list-group flush>
      <order-details
        v-for="orderline of orderlines"
        v-bind:orderline="orderline"
        v-bind:key="[orderline.item_id, orderline.choicestring, orderline.notes].join()"
        :sb_spinner="sb_spinner"
        @emit-adjust-line="emitAdjustOrderLine">
      </order-details>
    </b-list-group>
    <div class="mt-2 sb-info">
      <b-button variant="outline-dark" pill :disabled="sb_spinner" v-b-toggle.sidebar-orderdets>ADD SOMETHING ELSE</b-button>
    </div>
    <b-alert v-if="order_type==1" v-model="minDelAlert" variant="danger" class="mt-2 sb-alert" dismissible>Your order must total more than {{ selectedLocation.delivery_minimum | toCurrency }} for delivery</b-alert>
    <hr class="sb-line">
    <b-row>
      <b-col cols="8">Subtotal</b-col>
      <b-col class="orderdets-price">{{order_subtotal | toCurrency}}</b-col>
    </b-row>
    <hr class="sb-line">
    <b-row>
      <b-col class="sb-info">
        Choose Tip:
        <b>
          <span v-if="tip_select!=-1">{{ tip_select }}%</span>
          <span v-else>{{ customTip | toCurrency }}</span>
        </b>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="pl-2">
        <b-form-group>
          <b-form-radio-group
            id="tip-range"
            v-model="tip_select"
            :options="tipoptions"
            :disabled="sb_spinner"
            button-variant="outline-dark"
            class="tip-buttons"
            buttons
            name="radios-btn-default"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-collapse id="custom-tip-collapse" v-model="customTipVisible">
      <b-row>
        <b-col cols="3">Tip: $</b-col>
        <b-col>
          <b-form-input v-model="customTip" type="number" min="0.00" step="0.01" size="sm" :state="customTipState" class="sb-input" :disabled="sb_spinner"></b-form-input>
        </b-col>
      </b-row>
    </b-collapse>
    <hr class="sb-line">
    <b-row>
      <b-col cols="8">Tip, fees & taxes</b-col>
      <b-col class="orderdets-price">{{taxes_tips_fees | toCurrency}}</b-col>
    </b-row>
    <b-row v-if="order_subtotal>0 && orderoptions.ordertype=='1'" cols="1" class="orderdets-desc"><b-col>{{ selectedLocation.delivery_fee | toCurrency }} delivery fee included</b-col></b-row>
    <b-row v-if="order_subtotal>0" cols="1" class="orderdets-desc"><b-col>50¢ convenience fee included</b-col></b-row>
    <hr class="sb-line">
    <b-row>
      <b-col cols="8"><b-form-input v-model="discountcode" size="sm" class="sb-input" :disabled="sb_spinner" placeholder="Got a discount code?"></b-form-input></b-col>
      <b-col v-if="discount_total==0"><b-button pill size="sm" variant="outline-dark" :disabled="sb_spinner" @click="checkDiscountCode()">Use it!</b-button></b-col>
      <b-col v-if="discount_total>0"><b-button pill size="sm" variant="outline-dark" :disabled="sb_spinner" @click="discount = []; discount_total = 0;">Clear</b-button></b-col>
    </b-row>
    <hr class="sb-line">
    <b-row>
      <b-col cols="5"><h5>Total</h5></b-col>
      <b-col cols="3" style="color:green;" v-if="discount_total > 0">(-{{discount_total | toCurrency}})</b-col>
      <b-col cols="3" v-else></b-col>
      <b-col cols="4" class="orderdets-price"><h5>{{order_total | toCurrency}}</h5></b-col>
    </b-row>
    <hr class="sb-line">
    <b-row class="mb-2">
      <b-col><b-form-input v-model="order_notes" size="sm" class="sb-input" :disabled="sb_spinner" placeholder="Order notes, etc."></b-form-input></b-col>
    </b-row>
    <b-row class="mb-2">
        <b-alert v-model="phoneAlert" variant="danger" class="sb-alert" dismissible>Please provide a phone number!</b-alert>
        <b-alert v-model="tenDigitPhoneAlert" variant="warning" class="sb-alert" dismissible>This doesn't look like a valid number. You won't get your SMS notifications!</b-alert>
      <b-col cols="5">
        <b-form-select v-model="ccode_selected" :options="ccodes" size="sm" :disabled="sb_spinner" class="sb-input"></b-form-select>
      </b-col>
      <b-col cols="7">
        <b-form-input v-model="cust_phone" size="sm" class="sb-input" type="tel" :disabled="sb_spinner" placeholder="Cell Number" @change="phoneCheck()"></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-alert v-model="nameAlert" variant="danger" class="sb-alert" dismissible>Please provide your name!</b-alert>
      <b-col>
        <b-form-input v-model="cust_name" size="sm" class="sb-input" :disabled="sb_spinner" placeholder="Name your order"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-alert v-if="showemail==false" show variant="warning" class="sb-alert" dismissible>You won't receive a receipt without an email!</b-alert>
      <b-col>
        <b-form-checkbox
          v-model="showemail"
          :disabled="sb_spinner"
          switch
        > Send my receipt via email!</b-form-checkbox>
      </b-col>
    </b-row>
    <b-collapse id="emailInput" v-model="showemail">
      <b-row>
        <b-alert v-model="emailAlert" variant="danger" class="sb-alert" dismissible>Invalid Email!</b-alert>
        <b-col>
          <b-form-input v-model="cust_email" :disabled="sb_spinner" size="sm" class="sb-input" type="email" placeholder="Email addresss here!"></b-form-input>
        </b-col>
      </b-row>
    </b-collapse>

    <b-row class="mt-2" v-if="selectedLocation.accept_gift_cards">
      <b-col>
        <b-form-checkbox v-model="giftcard" :disabled="sb_spinner" name="giftcard" switch>I have a gift card!</b-form-checkbox>
      </b-col>
    </b-row>

    <div class="mt-2 sb-info">
      <b-alert v-model="orderlineAlert" variant="danger" class="sb-alert" dismissible>You have nothing on your order. Please add some items!</b-alert>
      <b-alert v-model="deliveryAlert" variant="danger" class="sb-alert" dismissible>Sorry we are unable to deliver to this address, it is too far away</b-alert>
      <b-alert v-model="tableAlert" variant="danger" class="sb-alert" dismissible>Please choose your table number</b-alert>
      <b-alert v-model="addressAlert" variant="danger" class="sb-alert" dismissible>Please choose a valid address</b-alert>
      <b-alert v-model="whenAlert" variant="danger" class="sb-alert" dismissible>Please choose when you want your order</b-alert>
      <b-alert v-model="tipAlert" variant="danger" class="sb-alert" dismissible>Please adjust your tip</b-alert>
      <b-row>
        <b-col>
          <b-button
            v-if="sb_spinner==false"
            id="submit"
            type="submit"
            class="my-2"
            variant="outline-dark"
            pill
            block
            @click="sb_spinner=true; validateform()"
          >LET'S PAY
          </b-button>

          <b-button
            v-if="sb_spinner==true"
            class="mb-2"
            variant="outline-dark"
            pill
            disabled
          ><b-spinner small type="grow"></b-spinner>&nbsp; Wait...
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col class="orderdets-desc sb-info" style="font-size: 0.75rem;">
          This site is protected by reCAPTCHA and the Google
          <a href="https://policies.google.com/privacy">Privacy Policy</a> and
          <a href="https://policies.google.com/terms">Terms of Service</a> apply.
        </b-col>
      </b-row>

      <GiftCardPaymentModal
        v-if="showGC"
        :gcDets="gcDetails"
       :order_total="order_total"
       :location_id="location_id"
       @emit-close-modal="closeGiftCardPaymentModal"
       @sidebaroverlay="removeSBOverlay">
     </GiftCardPaymentModal>

      <stripe-payment
        v-if="readyToPay"
        :pickupTime="estimatedPickupTime"
        :selectedMenuDate="selectedMenuDate"
        :selectedLocation="selectedLocation"
        :payment_intent="payment_intent"
        :location_landline="location_landline"
        :order_type="order_type"
        :timeslotIndex="timeslotIndex"
        :closing_time="closing_time"
        :order_subtotal="order_subtotal"
        :order_total="order_total"
        :outstandingAmount="outstandingAmount"
        :gcAmount="gcDetails.gcAmount"
        @notreadytopay="notReadyToPay"
        @emit-pay-gift-card="payRemainderOnGiftCard"
        @emit-error="emitError"
        @paymentstatus="afterPayment"
        @sidebaroverlay="removeSBOverlay">
      </stripe-payment>
      <b-row><b-col class="orderdets-desc sb-info" style="font-size: 0.75rem;">Once you place your order, you will receive a confirmation by SMS/text upon ordering and another SMS/text when your order is ready for pickup.</b-col></b-row>
      <b-row><b-col class="orderdets-desc sb-info" style="font-size: 0.75rem;">When you get here, skip the line and get your food.</b-col></b-row>
      <b-img class="mb-5" src="https://storage.googleapis.com/payoo-vendor-images/beat-the-line.png" fluid width="320px"></b-img>
    </div>
  </div>
</template>

<script>
import StripePayment from '@/components/StripePayment.vue'
import OrderDetails from '@/components/OrderDetails.vue'
import GiftCardPaymentModal from '@/components/GiftCardPaymentModal.vue'
import ccodejson from '@/json/countrycodes.json'
import moment from 'moment'

export default {
  name: 'Sidebar',
  components: {
    OrderDetails,
    GiftCardPaymentModal,
    StripePayment
  },
  props: ['orderlines', 'hours', 'vendor_id', 'location_id', 'orderline_total', "locations", "selectedMenuDate", "asap", "pickupState", "pickupTime", "orderoptions"],
  data () {
    return {
      readyToPay: false,
      payment_intent: [],
      ccode_selected: "1",
      nameAlert: false,
      phoneAlert: false,
      emailAlert: false,
      orderlineAlert: false,
      // recaptchaAlert: false,
      sb_spinner: false,
      tipoptions: [
        {text: 'None', value: 0},
        {text: '10%', value: 10},
        {text: '15%', value: 15},
        {text: '20%', value: 20},
        {text: 'Custom', value: -1}
      ],
      tip_select: 10,
      discountcode: '',
      discount: [],
      discount_total: 0,
      cust_name: '',
      cust_phone: '',
      cust_email: '',
      order_notes: '',
      recaptchaResponse: '',
      showemail: true,
      // pickupAppt: false,
      // pickupTime: '',
      // pickupState: true,
      // pickupAlert: false,
      deliveryAlert: false,
      nextTimeSlot: '',
      timeslotIndex: 0,
      timeslots: [],
      timer: '',
      closeTimeAlert: false,
      whenAlert: false,
      pastCloseTime: false,
      tenDigitPhoneAlert: false,
      deliveryDistance: 0,
      tableAlert: false,
      addressAlert: false,
      minDelAlert: false,
      // orderoptions: {
      //   cust_addr: '',
      //   address_confirmed: false,
      //   ordertype: '2',
      //   table: 0,
      // },
      customTip: 0,
      customTipVisible: false,
      giftcard: false,
      showGC: false,
      gcDetails: {},
      customTipState: true,
      tipAlert: false,
      updTimeSlot: ''
    }
  },

  created () {
    // this.timer = setInterval(this.retrievePickupTimes, 300000);
    // this.retrievePickupTimes();
  },

  beforeDestroy () {
    // clearInterval(this.timer);
  },

  watch: {
    tip_select: function() {
      if ((this.tip_select==-1 && this.customTipVisible==false) || (this.tip_select != -1 && this.customTipVisible==true)) {
        this.$root.$emit('bv::toggle::collapse', 'custom-tip-collapse');
      }
    },

    orderline_total: function() {
      // Upon change to the total, remove the minimum del alert, if appropriate
      if (this.minDelAlert==true && (this.selectedLocation.delivery_minimum<=this.orderline_total || this.order_type != 1)) {
        this.minDelAlert=false;
      }
      this.discount_total = 0;
      this.checkDiscountCode();
    },

    customTip: function() {
      const tipstr = String(this.customTip)
      if (this.customTip<0 || (tipstr.includes('.')) && tipstr.split('.')[1].length>2) {
        this.customTipState = false;
      } else {
        this.customTipState = true;
      }
    },

    // selectedMenuDate: function() {
    //   this.retrievePickupTimes();
    // }
  },

  computed: {
    outstandingAmount: function() {
      return ('giftcard' in this.payment_intent) ?
        Number(this.payment_intent.outstanding_balance) + Number(this.gcDetails.outstandingAmount) : this.gcDetails.outstandingAmount;
    },

    tenDigitPhone: function() {
      if (this.phone_number.match(/\d/g).length===11) {
        return true;
      } else {
        return false;
      }
    },

    closing_time: function() {
      if (Object.keys(this.hours).length > 0) {
        // return moment(this.todaysdate+'T'+this.hours[0].close_time);
        return moment(this.selectedMenuDate+'T'+this.hours[0].close_time);
      } else {
        return '';
      }
    },

    // last_orders: function() {
    //   //  (closing time - next_order_buffer)
    //   if (Object.keys(this.hours).length > 0 && Object.keys(this.selectedLocation).length > 0) {
    //     // return moment(this.todaysdate+'T'+this.hours[0].close_time).subtract(this.locations[0].next_appt_buffer, 'minutes');
    //     return moment(this.selectedMenuDate+'T'+this.hours[0].close_time).subtract(this.locations[0].next_appt_buffer, 'minutes');
    //   } else {
    //     return '';
    //   }
    // },

    estimatedPickupTime: function() {
      return (this.asap || this.updTimeSlot.length>0) ? this.nextTimeSlot : this.pickupTime;
    },

    order_type: function() {
      // NO LONGER USING ORDER TYPE 5
      // if the selected date isn't today or this.pickupAppt is true, it's an appointment (order type 5)
      // if (this.selectedMenuDate != moment().format('YYYY-MM-DD') || this.pickupAppt) {
      //   return '5';
      // } else {
      //   // use the order type set in the pickupDelivery component
      //   return this.orderoptions.ordertype;
      // }
      return this.orderoptions.ordertype;
    },

    selectedLocation: function() {
      return (Object.keys(this.locations).length > 0) ? this.locations[0] : '';
    },

    // location_mailing_address: function() {
    //   if (Object.keys(this.selectedLocation).length > 0) {
    //     const ad = this.selectedLocation.location_addresses.filter(addr => addr.address_type_id==1);
    //     return ad[0].address;
    //   } else {
    //     return '';
    //   }
    // },
    //
    location_landline: function() {
      if (Object.keys(this.selectedLocation).length > 0) {
        const ad = this.selectedLocation.location_addresses.filter(addr => addr.address_type_id==6);
        return ad[0].address;
      } else {
        return '';
      }
    },

    order_subtotal: function() {
      return this.orderline_total - this.discount_total;
    },

    pi_id: function() {
      if (Object.keys(this.payment_intent).length > 0) {
        var x = this.payment_intent.clientSecret.slice(3);
        var y = x.indexOf("_");
        return this.payment_intent.clientSecret.slice(0, (y+3));
      } else {
        return "";
      }
    },

    ccodes: function() {
      var codes = [];
      for (const cc of ccodejson) {
       codes.push({"value": cc.value, "text": cc.ccode + ' ' + cc.mcode})
      }
      return codes;
      },

    tax_total: function() {
      var taxes = 0;
      for (let i in this.locations) {
        if (i==0) {
          var taxrate = this.locations[i].tax_rate;
          taxes = this.order_subtotal * (Number(taxrate) / 100);
        }
      }
      // return taxes.toFixed(2);
      return Math.round((taxes + Number.EPSILON) * 100) / 100;
    },

    tip_total: function() {
      var tips = 0;
      if (this.tip_select!=-1) {
        tips = (Number(this.tip_select) / 100) * this.order_subtotal;
      } else {
        tips = Number(this.customTip);
      }
      // return tips.toFixed(2);
      return Math.round((tips + Number.EPSILON) * 100) / 100;
    },

    fees: function() {
      var fees = Number(0.50);
      if (this.orderoptions.ordertype==1) {
        fees += this.selectedLocation.delivery_fee;
      }
      return fees;
    },

    taxes_tips_fees: function() {
      // Don't show 50c added if nothing has been added to order
      if (this.order_subtotal==0) {
        return 0;
      } else {
        return Number(this.tax_total) + Number(this.tip_total) + this.fees;
      }
    },

    order_total: function() {
      var ordertotal = this.order_subtotal;
      // Don't show 50c added if nothing has been added to order
      if (ordertotal==0) {
        return 0;
      } else {
        ordertotal += this.taxes_tips_fees;
        return ordertotal;
      }
    },

    phone_number: function() {
        return String(this.ccode_selected) + String(this.cust_phone);
    },

  },

  methods: {
    emitError(error, severity, stage) {
      var orderdata = this.prepOrderInfo();
      this.$emit('emit-error', error, severity, stage, orderdata);
    },

    // adjusttype = 'add' - Add duplicate item with all options preset
    // adjusttype = 'edit' - Remove one quantity (remember options) and re-add with new options
    // adjusttype = 'remove' - Remove one from the quantity, remove item if qty = 1
    emitAdjustOrderLine(orderline, adjustType) {
      this.$emit('emit-adjust-line', orderline, adjustType);
    },

    // setCustAddress(cust_addr) {
    //   this.cust_addr=cust_addr;
    // },

    // setOrderOptions(orderoptions) {
    //   if (orderoptions.address_confirmed==true) {
    //     this.addressAlert=false;
    //   }
    //   if (orderoptions.table && orderoptions.table > 0) {
    //     this.tableAlert=false;
    //   }
    //   this.orderoptions = orderoptions;
    // },

    // setPickupDetails(pickupAppt, pickupTime, pickupState, timeslot_index) {
    //   this.pickupAppt=pickupAppt;
    //   this.pickupTime=pickupTime;
    //   this.pickupState=pickupState;
    //   this.timeslotIndex=timeslot_index;
    // },

    // setNextTimeSlot(nextTimeSlot) {
    //   this.nextTimeSlot = nextTimeSlot;
    // },

    // setDeliveryDistance(deldist) {
    //   this.deliveryAlert=false;
    //   this.deliveryDistance = deldist;
    //   if (this.deliveryDistance > this.selectedLocation.delivery_range) {
    //     this.deliveryAlert=true;
    //   }
    // },

    phoneCheck() {
      if (!this.tenDigitPhone) {
        this.tenDigitPhoneAlert = true;
      } else {
        this.tenDigitPhoneAlert = false;
      }
    },

    // retrievePickupTimes() {
    //   // this.$api.get('locations/'+this.location_id+'/pickuptimes?date='+this.todaysdate)
    //   this.$api.get('locations/'+this.location_id+'/pickuptimes?date='+this.selectedMenuDate)
    //     .then(response => {
    //
    //      // JSON responses are automatically parsed.
    //      this.timeslots = response.data.time_slots
    //      this.nextTimeSlot = response.data.next_time_slot
    //      // this.$emit('emit-next-timeslot', response.data.next_time_slot);
    //     })
    //     .catch(e => {
    //      this.emitError(e.stack, 3, 'retrievePickupTimes');
    //     })
    // },

    checkDiscountCode() {
      if (this.discountcode != '') {
        this.$api.get('vendor/'+this.vendor_id+'/discounts?code='+this.discountcode)
        .then(response => {
         this.discount = response.data;
         if (this.discount.discount_amount > 0) {
           this.discount_total = this.discount.discount_amount;
         }
         if (this.discount.discount_percent > 0) {
           this.discount_total = this.order_subtotal * (Number(this.discount.discount_percent/100));
         }
        })
        .catch(e => {
         this.emitError(e.stack, 3, 'checkDiscountCode');
        })
      }
    },

    validateEmail() {
      if (this.showemail) {
        if (!this.cust_email) {
          return false;
        } else {
          var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(this.cust_email);
        }
      } else {
        return true;
      }
    },

    closeGiftCardPaymentModal(gcdetails, cancel) {
      this.showGC=false
      this.sb_spinner=false
      if (!cancel) {
        this.gcDetails=gcdetails
        // decide if we create a new payment intent or update an existing one
        if (this.pi_id != "") {
          this.updateIntent();
        } else {
          this.loadIntent();
        }
      }
    },

    async loadSetRecaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()
      // Execute reCAPTCHA with action "submit".
      const token = await this.$recaptcha('submit')
      // capture token to send to server for validation
      this.recaptchaResponse=token;
    },

    // validates the form has required elements prior to loading the payment intent
    async validateform() {
      var validData = await this.checkFormData();
      await this.loadSetRecaptcha()
      if (validData==true) {
        // Is the customer using a giftcard?
        if (this.giftcard==true) {
          // pop a modal asking how much of the ordertotal they want to put on their card
          this.showGC=true;
        } else {
          // decide if we create a new payment intent or update an existing one
          if (this.pi_id != "") {
            this.updateIntent();
          } else {
            this.loadIntent();
          }
        }
      }
    },

    checkFormData() {
      var validData = true;

      // // Check current time is within 5 mins of last orders
      // if (moment().isAfter(this.last_orders.add(5, 'minutes'))) {
      //   validData=false;
      //   this.pastCloseTime=true;
      //   this.closeTimeAlert=true;
      //   this.sb_spinner=false;
      // }

      // Check custom tip is above 0 and is 2dp
      if (this.tip_select == -1 && this.customTipState == false) {
        validData=false;
        this.tipAlert=true;
        this.sb_spinner=false;
      }

      // Check valid pickup state or asap
      if (!this.asap && !this.pickupState) {
        validData=false;
        this.whenAlert=true;
        this.sb_spinner=false;
      }

      // Check for order contents
      if (this.orderlines.length == 0) {
        validData=false;
        this.orderlineAlert = true;
        this.sb_spinner = false;
      }

      // Check for phone number if not table /counter order
      if (!this.cust_phone && this.order_type != '4'  && this.order_type != '3') {
        validData=false;
        this.phoneAlert = true;
        this.sb_spinner = false;
      }

      // CHeck for customer name if not table / counter order
      if (!this.cust_name && this.order_type != '4'  && this.order_type != '3') {
        validData=false;
        this.nameAlert = true;
        this.sb_spinner = false;
      }

      // no email warning
      var emailok = this.validateEmail();
      if (!emailok) {
        validData=false;
        this.emailAlert = true;
        this.sb_spinner = false;
      }

      // // order type == pickup, pickup appt set and an invalid pickup time selected
      // if (!this.pickupState && this.pickupAppt && this.orderoptions.ordertype == '2') {
      //   validData=false;
      //   this.pickupAlert = true;
      //   this.sb_spinner = false;
      // }

      // Check the delivery distance again before proceeding
      if (this.deliveryDistance > this.selectedLocation.delivery_range && this.orderoptions.ordertype == '1') {
        validData=false;
        this.deliveryAlert = true;
        this.sb_spinner = false;
      }

      // Check for address if delivery
      if (this.order_type=='1' && (this.orderoptions.address_confirmed==false || this.orderoptions.cust_addr=='')) {
        validData=false;
        this.addressAlert = true;
        this.sb_spinner = false;
      }

      // Check subtotal > minimum delivery amount if delivery
      if (this.order_type=='1' && this.orderline_total < this.selectedLocation.delivery_minimum) {
        validData=false;
        this.minDelAlert = true;
        this.sb_spinner = false;
      }

      // Check for table number if dine in
      if (this.order_type=='4' && (this.orderoptions.table==0 || !this.orderoptions.table)) {
        validData=false;
        this.tableAlert = true;
        this.sb_spinner = false;
      }
      return validData;
    },

    async retrieveNextPickupTime() {
      const res = await this.$api.get('locations/'+this.selectedLocation.id+'/pickuptimes?date='+this.selectedMenuDate)
      try {
        if (res.data.success==true) {
          this.timeslots = await res.data.time_slots
          this.nextTimeSlot = await res.data.next_time_slot
        }
      }
      catch (error) {
       this.emitError(error.stack, 3, 'retrievePickupTimes');
      }
    },

    async formatPickupTime() {
      this.updTimeSlot = '';
      await this.retrieveNextPickupTime();
      if (this.asap) {
        return this.selectedMenuDate + ' ' + this.nextTimeSlot.slice(0,5);
      } else {
        const pickupDateTime = this.selectedMenuDate + ' ' + this.pickupTime
        if (this.timeslots.indexOf(pickupDateTime) != -1) {
          return this.selectedMenuDate + ' ' + this.pickupTime.slice(0,5);
        } else {
          this.$bvToast.toast('Assigned pickup time of '+this.$options.filters.toTwelveHours(this.nextTimeSlot)+'. If this is not suitable, return to the calendar to choose another time.', {
            title: 'Pickup Time no longer available',
            autoHideDelay: 5000,
            variant: "secondary",
            toaster: "b-toaster-top-center",
            solid: true
          })
          this.updTimeSlot = this.nextTimeSlot;
          return this.selectedMenuDate + ' ' + this.nextTimeSlot.slice(0,5);
        }
      }
      // this.pickupTime = (this.pickupTime == '') ? this.nextTimeSlot : this.pickupTime;
      // var today = moment().format('YYYY-MM-DD');
    },

    // Prepare orderinfo for posting / patching
    async prepOrderInfo() {
      var pickup_time = await this.formatPickupTime();
      var orderlines = [];
      for (const line of this.orderlines) {
        // empty options if there is a topup amount (giftcard line)
        const options = (line.gcTopUpAmount || line.gcCardNumber) ? [] : line.choicearray
        orderlines.push(
          {
            "item_id": line.item_id,
            "quantity": line.qty,
            "notes": line.notes,
            "options": options,
            "gcCardNumber": line.gcCardNumber,
            "gcTopUpAmount": line.gcTopUpAmount
          }
        )
      }
      // Fill giftcard variables if there is GC info
      const gcamount = 'gcAmount' in this.gcDetails ? this.gcDetails.gcAmount : 0
      const gcaccno = 'gcAccountNumber' in this.gcDetails ? this.gcDetails.gcAccountNumber : ''
      const gcpin = 'gcPin' in this.gcDetails ? this.gcDetails.gcPin : ''
      const outstanding = ('outstandingAmount' in this.gcDetails && this.giftcard) ? this.gcDetails.outstandingAmount : 0
      const paymethod = (this.giftcard == true && outstanding == 0) ? 4 : 2
      const customtip = this.tip_select==-1 ? Number(this.tip_total) : 0

      var data = {
        "payoo_public_secret": process.env.VUE_APP_PAYOO_PUBLIC_SECRET,
        "recaptcha_response": this.recaptchaResponse,
        "cust_name": this.cust_name,
        "cust_phone": this.phone_number,
        "cust_email": this.cust_email,
        "cust_addr": this.orderoptions.cust_addr,
        "order_type": Number(this.order_type),
        "table_number": this.orderoptions.table,
        "pickup_time": pickup_time,
        "discount_code": this.discountcode,
        "tip": Number(this.tip_select),
        "custom_tip": customtip,
        "order_notes": this.order_notes,
        "how_taken": "Web",
        "payment_type": paymethod,
        "gc_amount": gcamount,
        "gc_accno": gcaccno,
        "gc_pin": gcpin,
        "gc_outstanding": outstanding,
        "orderlines": orderlines
      };

      return data;
    },

    errorCreateUpdatePIModal(msgtype=1) {
      var msg = "We're sorry, there was a problem taking your order. Please refresh the site and try again or give us a call on "+this.location_landline
      if (msgtype==2) {
        msg = "Your gift card account number is invalid, please verify and try again."
      }
      // display error modal message if issue with creating /updating payment intent and / or Payoo order
      this.$bvModal.msgBoxOk(msg, {
        title: 'Error sending order',
        centered: true
      })
      this.sb_spinner=false;
    },

    async payRemainderOnGiftCard() {
      // set outstandingAmount as 0 (paid by CC)
      this.gcDetails.outstandingAmount=0
      await this.loadSetRecaptcha()
      // update order and pay gift card amount
      this.updateIntent()
    },

    /*
    Loads the payment intent key for the user to pay.
    */
    async loadIntent() {
      var data = await this.prepOrderInfo();
      this.postOrderRequest(data);
    },

    postOrderRequest(data) {
       // create order with status of 'open' and payment intent with stripe
      this.$api.post('/locations/'+this.location_id+'/weborder', data)
        .then( function( response ){
          if (response.data.created == true) {
            // log order details and secret
            this.payment_intent = response.data;
            if (this.giftcard && this.gcDetails.outstandingAmount==0) {
              // if giftcard was used and everything paid - complete the order
              this.afterPayment(this.pickupTime)
            } else {
              // otherwise pop Stripe Payment Modal
              this.readyToPay=true;
            }
          } else if (response.data.invaliditem==true) {
            this.$bvModal.msgBoxOk('The order contains an item - '+response.data.item+', which is not available on the selected day or is out of stock. Please choose something else from our menu and resubmit', {
              title: 'Selected item unavailable',
              centered: true
            })
            this.sb_spinner=false;
          }
        }.bind(this))
        .catch(e => {
          if (e.response.data.description=='Gift card account number not valid') {
            this.errorCreateUpdatePIModal(2)
          } else {
            this.emitError(e.stack, 5, 'load Payment Intent / create initial order');
            this.errorCreateUpdatePIModal();
          }
        })
    },

    /*
    Updates an existing payment intent for the user to pay.
    */
    async updateIntent() {
      var data = await this.prepOrderInfo();
      this.patchOrderRequest(data)
    },

    patchOrderRequest(data) {
      data["payment_intent_id"]=this.pi_id;
       // create order with status of 'open' and payment intent with stripe
      this.$api.patch('/weborder/'+this.payment_intent.new_order_id, data)
        .then( function( response ){
          if (response.data.success == true) {
            // log order details and secret
            this.payment_intent = response.data;
            if (this.giftcard && this.gcDetails.outstandingAmount==0) {
              // if giftcard was used and everything paid - complete the order
              this.afterPayment(this.pickupTime)
            } else {
              // otherwise pop Stripe Payment Modal
              this.readyToPay=true;
            }
          } else if (response.data.invaliditem==true) {
            this.$bvModal.msgBoxOk('The order contains an item - '+response.data.item+', which is not available on the selected day or is out of stock. Please choose something else from our menu and resubmit', {
              title: 'Selected item unavailable',
              centered: true
            })
            this.sb_spinner=false;
          }
        }.bind(this))
        .catch(e => {
          if (e.response.data.description=='Gift card account number not valid') {
            this.errorCreateUpdatePIModal(2)
          } else {
            this.emitError(e.stack, 5, 'load Payment Intent / create initial order');
            this.errorCreateUpdatePIModal();
          }
        })
    },

    afterPayment(pickupTime) {
      this.emptyBasket();
      this.$emit('emit-payment-succeeded', this.payment_intent, pickupTime, this.order_type, this.selectedLocation.delivery_time, this.orderoptions.cust_addr);
    },

    removeSBOverlay(overlay) {
      this.sb_spinner=overlay;
    },

    notReadyToPay() {
      // this.retrievePickupTimes();
      this.readyToPay = false;
    },

    emptyBasket() {
      const request = window.indexedDB.open("basket_db");
      request.onsuccess = () => {
        const db = request.result;
        const transaction = db.transaction([ "order" ], "readwrite");
        const orderStore = transaction.objectStore("order");
        orderStore.clear();
        transaction.oncomplete = () => {
          db.close();
        };
      };
    },
  },

}
</script>

<style>

@import '../styles/style.css';

</style>
